import createEntityBundle from '~/src/Lib/createEntityBundle'
import { KpiProfile as schema } from '~/src/Store/Schemas'

const bundle = createEntityBundle({
  name: 'kpiProfiles',
  apiConfig: { schema, url: 'kpiProfiles' },
})

export default bundle
